  <div class="skip-to-content">
    <button (click)="skipToContent()" role="link" id="btn-portal-skip-to-content">Skip to main content.</button>
  </div>
  <!--<button role="link" id="btn-portal-skip-to-content" aria-description="Skip to Main Content" (click)="skipToContent()" >Skip to Main Content </button>-->
  <router-outlet></router-outlet>

